const DEFAULT_ALLOWED_MIME_TYPES = ["image/jpeg", "image/png"];
const DEFAULT_ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png"];

export const IMAGE_UPLOAD_ACCEPT = DEFAULT_ALLOWED_MIME_TYPES.join(",");

export const USER_AVATAR_IMAGE_RULES = {
    label: "la foto de usuario",
    maxSizeMB: 10,
    allowedMimeTypes: DEFAULT_ALLOWED_MIME_TYPES,
    allowedExtensions: DEFAULT_ALLOWED_EXTENSIONS,
};

export const ALMACEN_IMAGE_RULES = {
    label: "la foto de la tienda",
    maxSizeMB: 10,
    allowedMimeTypes: DEFAULT_ALLOWED_MIME_TYPES,
    allowedExtensions: DEFAULT_ALLOWED_EXTENSIONS,
};

const formatFileSize = (bytes = 0) => {
    if (!Number.isFinite(bytes) || bytes <= 0) return "0 MB";
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(1)} MB`;
    const kb = bytes / 1024;
    return `${kb.toFixed(0)} KB`;
};

const hasAllowedExtension = (fileName = "", allowedExtensions = []) => {
    const normalizedName = String(fileName || "").toLowerCase();
    return allowedExtensions.some((extension) => normalizedName.endsWith(extension));
};

const readImageDimensions = (file) =>
    new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();

        image.onload = () => {
            resolve({
                width: image.naturalWidth || image.width,
                height: image.naturalHeight || image.height,
            });
            URL.revokeObjectURL(objectUrl);
        };

        image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error("No se pudo leer la imagen."));
        };

        image.src = objectUrl;
    });

export const readFileAsDataUrl = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(String(reader.result || ""));
        reader.onerror = () => reject(new Error("No se pudo preparar la vista previa de la imagen."));
        reader.readAsDataURL(file);
    });

export const validateImageUpload = async (file, config = {}) => {
    const {
        label = "la imagen",
        maxSizeMB = 5,
        allowedMimeTypes = DEFAULT_ALLOWED_MIME_TYPES,
        allowedExtensions = DEFAULT_ALLOWED_EXTENSIONS,
    } = config;

    if (!file) {
        return { ok: false, error: `No se seleccionó ${label}.` };
    }

    const fileType = String(file.type || "").toLowerCase();
    const typeAllowed =
        allowedMimeTypes.includes(fileType) || hasAllowedExtension(file.name, allowedExtensions);

    if (!typeAllowed) {
        return {
            ok: false,
            error: `Formato no permitido para ${label}. Usa JPG o PNG.`,
        };
    }

    const maxSizeBytes = maxSizeMB * 1024 * 1024;
    if (file.size > maxSizeBytes) {
        return {
            ok: false,
            error: `${label.charAt(0).toUpperCase() + label.slice(1)} debe pesar menos de ${maxSizeMB} MB. Archivo actual: ${formatFileSize(file.size)}.`,
        };
    }

    try {
        const { width, height } = await readImageDimensions(file);
        return { ok: true, width, height };
    } catch (error) {
        return {
            ok: false,
            error: error?.message || `No se pudo validar ${label}.`,
        };
    }
};
